import { Inbox } from "lucide-react";

const EmptyState = ({
    icon: Icon = Inbox,
    title = "Geen echte data beschikbaar",
    description = "Het dashboard blijft leeg totdat scans echte listings uit aangesloten bronnen retourneren.",
    action,
    testid = "empty-state",
    image,
}) => (
    <div
        className="empty-frame rounded-lg p-10 md:p-16 text-center flex flex-col items-center gap-5"
        data-testid={testid}
    >
        {image ? (
            <img
                src={image}
                alt=""
                className="w-32 h-32 object-contain opacity-90"
                aria-hidden
            />
        ) : (
            <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center text-muted-foreground">
                <Icon className="w-6 h-6" />
            </div>
        )}
        <div className="max-w-md">
            <h3 className="font-grotesk text-lg font-semibold text-foreground">
                {title}
            </h3>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                {description}
            </p>
        </div>
        {action && <div className="mt-1">{action}</div>}
    </div>
);

export default EmptyState;
